import {
  Component,
  Output,
  EventEmitter,
  Input,
  signal,
  ViewEncapsulation,
  inject,
} from "@angular/core";
import { CoreService } from "src/app/data/datasource/local/core.service";
import { MatDialog } from "@angular/material/dialog";
import { ModuloService, PantallaBuscable } from "src/app/data/datasource/local/modulo.service";
import { ModuloSwitcherComponent } from "./modulo-switcher.component";
import { TranslateService } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { MaterialModule } from "src/app/material.module";
import { Router, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgScrollbarModule } from "ngx-scrollbar";
import { AppSettings } from "src/app/config";
import { MatDividerModule } from "@angular/material/divider";
import { AuthService } from "src/app/core/auth/services/auth.service";

interface notifications {
  id: number;
  icon: string;
  color: string;
  title: string;
  time: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  title: string;
  link: string;
  new?: boolean;
}

@Component({
  selector: "app-header",
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    ModuloSwitcherComponent,
  ],
  templateUrl: "./header.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  isCollapse: boolean = false; // Initially hidden

  toggleCollpase() {
    this.isCollapse = !this.isCollapse; // Toggle visibility
  }

  public selectedLanguage: any = {
    language: "Español",
    code: "es",
    type: "MX",
    icon: "/assets/images/flag/icon-flag-es.svg",
  };

  public languages: any[] = [
    {
      language: "English",
      code: "en",
      type: "US",
      icon: "/assets/images/flag/icon-flag-en.svg",
    },
    {
      language: "Español",
      code: "es",
      type: "MX",
      icon: "/assets/images/flag/icon-flag-es.svg",
    },
  ];
  /*{
    language: "Français",
    code: "fr",
    icon: "/assets/images/flag/icon-flag-fr.svg",
  },
  {
    language: "German",
    code: "de",
    icon: "/assets/images/flag/icon-flag-de.svg",
  }, */

  @Output() optionsChange = new EventEmitter<AppSettings>();

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
  ) {
    translate.setDefaultLang("es");
  }

  options = this.settings.getOptions();

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  notifications: notifications[] = [
    {
      id: 1,
      icon: "a-b-2",
      color: "primary",
      time: "8:30 AM",
      title: "Launch Admin",
      subtitle: "Just see the my new admin!",
    },
    {
      id: 2,
      icon: "calendar",
      color: "secondary",
      time: "8:21 AM",
      title: "Event today",
      subtitle: "Just a reminder that you have event",
    },
    {
      id: 3,
      icon: "settings",
      color: "warning",
      time: "8:05 AM",
      title: "Settings",
      subtitle: "You can customize this template",
    },
    {
      id: 4,
      icon: "a-b-2",
      color: "success",
      time: "7:30 AM",
      title: "Launch Templates",
      subtitle: "Just see the my new admin!",
    },
    {
      id: 5,
      icon: "exclamation-circle",
      color: "error",
      time: "7:03 AM",
      title: "Event tomorrow",
      subtitle: "Just a reminder that you have event",
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      title: "My Profile",
      link: "/",
    },
    {
      id: 2,
      title: "My Subscription",
      link: "/",
    },
    {
      id: 3,
      title: "My Invoice",
      new: true,
      link: "/",
    },
    {
      id: 4,
      title: " Account Settings",
      link: "/",
    },
  ];

  signOut(): void {
    this.authService.signOut().subscribe(() => {
      this.router.navigate(['/session/login']);
    });
  }

}

@Component({
  selector: "search-dialog",
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    MatDividerModule,
  ],
  templateUrl: "search-dialog.component.html",
})
export class AppSearchDialogComponent {
  searchText: string = "";

  /** Pantallas de todos los módulos (Comercial, Obras, Transporte). */
  private pantallas = inject(ModuloService).todasLasPantallas;

  get resultados(): PantallaBuscable[] {
    const q = normalizar(this.searchText);
    if (!q) return this.pantallas;
    return this.pantallas.filter((p) =>
      normalizar(`${p.displayName} ${p.grupo ?? ""} ${p.modulo}`).includes(q)
    );
  }
}

/** Minúsculas y sin acentos, para buscar "catalogos" o "catálogos" igual. */
function normalizar(s: string | undefined): string {
  return (s ?? "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
}
